module.exports = __webpack_public_path__ + "assets/img/re13.88ccd74b.png";